export enum FeatureAccess{
    None = "N",
    View = "V",
    Manage = "M"
}